const colors = {
  COMPLETED: 'bg-green-subtle text-green-success',
  CUSTOMER_SUBMITTED: 'bg-turquoise-subtle text-turquoise-secondary',
  CREATED: 'bg-red-subtle text-red-secondary',
};

const REFUND_STATUS = [
  'COMPLETED',
  'CUSTOMER_SUBMITTED',
  'CREATED'
]

export {
  colors,
  REFUND_STATUS
}